import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams, Link } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";
import Chart from "react-apexcharts";
import moment from "moment";
let apiServices = new ApiService();
const GoalDetail = () => {
  let history = useHistory();
  const { id } = useParams();
  const didMountRef = useRef(true);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [graphData, setgraphData] = useState([]);
  const [showgraph, Setshowgraph] = useState(false);
  const [txndata, settxndata] = useState([]);
  const [transcdata, setTranscdata] = useState([])
  useEffect(() => {
    if (didMountRef.current) {
      const usergraphdatastring = {
        "goalid": id,
      }
      apiServices.getgoalgraphdata(usergraphdatastring).then(result => {
        if (result.data.status == 'success') {
          var graphdata = result.data.graphdata[0];

          if (graphdata != null) {
            setgraphData(graphdata);
            Setshowgraph(true)
          }
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
        }
      })
      gettransactiondata();
    }
    didMountRef.current = false;
  }, []);
  const gettransactiondata = () => {
    setSpinnerLoading(true);
    const dataString = {
      "goal_id": id
    }
    apiServices.getusertransactionsdata(dataString).then(res => {
      if (res.data.status == 'success') {
        settxndata(res.data.txndata);
        setTranscdata(res.data.data)
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
      }
    })}
  const guestSeries = [
    {
      name: 'Invested',
      type: 'column',
      data: graphData.invested
    }, {
      name: 'Planned',
      type: 'area',
      data: graphData.planned
    }, {
      name: 'Actual',
      type: 'line',
      data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
    }
  ];
  const guestOption = {
    chart: {
      toolbar: {
        show: false
      },
      height: 200,
      type: 'line',
      stacked: false,
    },
    stroke: {
      width: [0, 3, 3],
      curve: 'smooth'
    },
    plotOptions: {
      bar: {
        columnWidth: '30%'
      }
    },
    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: 'light',
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100]
      }
    },
    labels: graphData.years,
    markers: {
      size: [0, 3, 0]
    },
    xaxis: {
      tickAmount: 6,
    },
    yaxis: {
      title: {
        text: '',
      },
      tickAmount: 7,
     min: 0,
   },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0) + " Rs";
          }
          return y;
        }
      }
    }
  };
 return (
    <div>
      <Header />
      <section className='bg-gray-light section-small'>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="row mg-t-20">
            {showgraph == true ?
              <div className="col-lg-12 col-12">
                <div className='goalsetting-block mg-b-15'>
                  <div className='row'>
                    <div className='col-lg-7 border-right'>
                      <h4 className='tx-18'>{graphData.goaldetails.name}</h4>
                      <h6 className='tx-13 mg-b-5'>{graphData.goaldetails.type}</h6>
                      <div className='goalsetting-list'>
                        <ul>
                          <li>Amount :<span>₹{graphData.goaldetails.amount}</span></li>
                          <li>Current Investment : <span>₹{graphData.goaldetails.current}</span></li>
                          <li>Maturity Year :<span>{graphData.goaldetails.maturity}</span></li>
                          <li>Goal Start Date :<span>{graphData.goaldetails.datetime}</span></li>
                          <li>Folio No :<span>-</span></li>
                        </ul>
                      </div>
                      {/* {
           Clickhere == 1?
         <Link to={`/sipinvestment/${graphData.goaldetails.gs_id}`} class="mg-t-20 buttonab-line-3">Start Investment <i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
           :''
       } */}
                    </div>
                    <div className='col-lg-5'>
                        <Chart type="line" series={guestSeries} options={guestOption} width='100%' />
                    </div>
                  </div>
                </div>
                {transcdata.map((value) => (
                  value.transactiondetail.map((key) => (
                    <div className='col-lg-12'>
                     <div className='mfsipbox mg-b-15' style={{ paddingBottom: "0px", paddingTop: "10px" }}>
                        <div className='mfsipbox-planname'>{key.txn_mf_name}</div>
                        <div className='mfshipboxform'>
                          <div className='row'>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                Transaction Id : {key.txn_order_id}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                SIP Start On :  {key.txn_sip_startday}/{key.txn_sip_startmonth}/{key.txn_sip_startyear}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                SIP Amount : ₹  {key.txn_amount}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                SIP Ends In : {key.txn_sip_endmonth}/{key.txn_sip_endyear}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                Transaction Date : {moment(value.created_at).format('YYYY-MM-DD')}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                status :
                                {(() => {
                                  if (value.trans_status == 1) {
                                    return (
                                      <div className="badge bg-info">Transaction Processed</div>
                                    )
                                  } else if (value.trans_status == 2) {
                                    return (
                                      <div className="badge bg-danger">Transaction Failed</div>
                                    )
                                  } else if (value.trans_status == 3) {
                                    return (
                                      <div className="badge bg-success">Transaction Successfull</div>
                                    )
                                  } else {
                                    return (
                                      <div className="badge bg-warning">Transaction Pending</div>
                                    )
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ))}
              </div>
              : ''}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default GoalDetail;